import { Component, AfterViewInit, ViewChild, ElementRef, DoCheck } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';
import * as encoding from 'encoding-japanese';
import { SalesGroupOwnerService } from '../../../service/sales-group-owner/sales-group-owner.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { AgGridHelper } from '../../../util/AgGridHelper';

@Component({
  selector: 'app-wa9166',
  templateUrl: './wa9166.component.html',
  styleUrls: ['./wa9166.component.scss']
})
export class Wa9166Component implements AfterViewInit, DoCheck {
  private gridApi: any;
  public componentTitle = 'WA9166:荷主別売上摘要マスタ照会';
  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];
  public config = config;
  public ownerId: number;
  public ownerResult: any;
  public working = false;
  public working2 = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';
  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;
  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;
  private isShowSearchBlock = true;
  private isEnableClearFilter = null;
  private isShowSendLoading = false;
  private selectedCount = 0;

  public rowsPerPageModel = [{ value: 10, viewValue: '10' }, { value: 20, viewValue: '20' }, { value: 100, viewValue: '100' }, { value: 500, viewValue: '500' }];
  public rowsPerPage = config.rowsPerPageSize;
  private delete: boolean = false;
  public wa9168data: object = [];
  public selectedOwnerId;

  private isOwnerSearchNone = false;
  private isShow9167 = false;

  constructor(private router: Router, private salesGroupOwnerService: SalesGroupOwnerService, private commonService: CommonService, private dialogsService: DialogsService) {
    this.gridHelper = new AgGridHelper();
    this.gridHelper.gridSelectionCheckboxStyle = 'radio';
    this.gridOptions = <GridOptions>{
      rowSelection: 'single',
      floatingFilter: true,
      pagination: true,
      paginationPageSize: this.rowsPerPage,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa9166_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.gridHelper.renderGridCheckboxImage();
        this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
      },
      onFilterChanged: () => {
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      },
      onPaginationChanged: () => {
        this.errorInfo = '';
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;
        this.gridHelper.renderScrollArrow();
        this.gridHelper.renderGridCheckboxImage();
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelectionFilteredOnly: true,
        width: 30,
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        headerCheckboxSelection: false,
        suppressMenu: true,
        pinned: 'left',
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        unSortIcon: true,
        sort: 'asc',
        width: this.getColumnWidth('ownerCd', 100),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        unSortIcon: true,
        width: this.getColumnWidth('ownerTx', 200),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '売上摘要コード',
        field: 'salesgroupCd',
        unSortIcon: true,
        sort: 'asc',
        width: this.getColumnWidth('salesgroupCd', 100),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '売上摘要名',
        field: 'salesgroupTx',
        unSortIcon: true,
        width: this.getColumnWidth('salesgroupTx', 200),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '単価',
        field: 'unitpricedispNr',
        unSortIcon: true,
        width: this.getColumnWidth('unitpricedispNr', 100),
        valueFormatter: insertcomma,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '課税区分',
        field: 'typetaxTx',
        unSortIcon: true,
        width: this.getColumnWidth('typetaxTx', 100),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        unSortIcon: true,
        width: this.getColumnWidth('updDt', 200),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        unSortIcon: true,
        width: this.getColumnWidth('upduserTx', 100),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        unSortIcon: true,
        width: this.getColumnWidth('addDt', 200),
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        unSortIcon: true,
        width: this.getColumnWidth('adduserTx', 100),
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.ownerResult = sessionStorage.getItem('ownerResult');
    if (this.ownerResult !== null) {
      const selectedOwner = JSON.parse(this.ownerResult);
      this.ownerId = selectedOwner.ownerId;
    }
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonDubleMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.gridHelper.setGridOptions(this.gridOptions);
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa9166_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa9166_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa9166_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonDubleMargin;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.onSubmit();
  }

  reg() {
    sessionStorage.removeItem('isShowOwnerSelect');
    //sessionStorage.setItem('wa9167openotherwindow', 'open');
    this.isShow9167 = true;
  }

  onClose9167(isRefreshGrid: boolean) {
    this.isShow9167 = false;
    if (isRefreshGrid) this.onSubmit();
  }

  upd() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }
    sessionStorage.setItem('wa9168openotherwindow', 'open');
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    this.wa9168data = this.rowData[selectedIndex];
  }

  del() {
    this.isShowSendLoading = true;
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      this.isShowSendLoading = false;
      //SWMS-1186
      this.delete = false;
      return;
    }
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    const selectedId = this.rowData[selectedIndex]['ownerId'];
    const selectedId2 = this.rowData[selectedIndex]['salesgroupId'];
    this.salesGroupOwnerService
      .delete(selectedId, selectedId2)
      .then(outputJson => {
        this.delete = false;
        this.onSubmit();
        this.isShowSendLoading = false;
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.delete = false;
        this.isShowSendLoading = false;
      });
  }

  onSubmit() {
    //SW-2103　ダブルクリック抑止
    if (this.working2) return;
    this.working2 = true;
    this.gridOptions.api.showLoadingOverlay();
    this.onFilterClear();
    this.salesGroupOwnerService
      .get(this.ownerId)
      .then(outputJson => {
        this.rowData = outputJson.salesgroupowners;
        setTimeout(() => {
          this.gridOptions.api.hideOverlay();
          this.working2 = false;
        },300);
      })
      .catch(error => {
        this.working2 = false;
        this.gridOptions.api.hideOverlay();
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }
  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
    this.selectedCount = 0;
  }

  changeOwner(selectedOwnerId) {
    this.selectedOwnerId = selectedOwnerId;
    if (selectedOwnerId !== null) {
      if (selectedOwnerId !== undefined) {
        this.ownerId = selectedOwnerId;
      } else {
        this.ownerId = undefined;
      }
      this.onSubmit();
    } else {
      this.rowData = [];

      this.gridOptions.api.deselectAll();
    }
  }

  ngDoCheck() {
    if (this.selectedCount > 0) {
      this.working = true;
    } else {
      this.working = false;
    }
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }

  paginatorRowChange() {
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9166/wa9166.component.ts